import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import "./App.css";
import LandingPage from "./Pages/LandingPage/LandingPage";
import OurStory from "./Pages/OurStory/OurStoryNew/OurStory";
import emailjs from "@emailjs/browser";
import Sent from "./Pages/Sent/Sent";
import Soon from "./Pages/Soon/Soon";
import Products from "./Pages/Products2/ProductsNew";
import Investment from "./Pages/Investment/InvestmentNew";
import News from "./Pages/News/NewsNew";
import ResetPassword from "./Pages/ResetPassword/ResetPassword";
import ForgotPassword from "./Pages/ForgotPassword/ForgotPassword";
import UserManagement from "./Pages/UserManagement/UserManagement";
import ContactManagement from "./Pages/ContactManagement/ContactManagement";
import ContactManagementView from "./Pages/ContactManagement/ContactManagementView";
import ContactAdd from "./Pages/ContactManagement/ContactAdd";
import ContactMatch from "./Pages/ContactManagement/ContactMatch";

import { Sections as OurStorySec } from "./Pages/OurStory/OurStoryNew/OurStory";
import { Sections as ProductsSec } from "./Pages/Products2/ProductsNew";
import { Sections as NewsSec } from "./Pages/News/NewsNew";
import { Sections as InvestorSec } from "./Pages/Investment/InvestmentNew";

import ContractStatus from "./Pages/UserManagement/ContractStatus";
import UserActivity from "./Pages/UserManagement/UserActivity";
import Register from "./Pages/Register/Register";
import UserLogin from "./Pages/UserLogin/Login";
import Leadership from "./Pages/Leadership/Leadership";
import { AuthProvider } from "./Context/AuthContext";
import { UserProvider } from "./Context/UserContext";
import Contact from "./Pages/Contact/Contact";

import UserForm from "./Pages/UserManagement/UserForm";
import PrivateRoute from "./Components/PrivateRoute";
import Profile from "./Pages/Profile/Profile";
import RoleAdminDashboard from "./Pages/RoleAdminDashboard/RoleAdminDashboard";
import { RoleEditor } from "./Pages/RoleEditor/RoleEditor";
import { UserPermissionManager } from "./Pages/UserPermissionManager/UserPermissionManager";
import { PermissionEditor } from "./Pages/PermissionEditor/PermissionEditor";
import { RolePermissionAssigner } from "./Pages/RolePermissionAssigner/RolePermissionAssigner";
import { useEffect } from "react";
// import OtherInfo from "./Pages/OtherInfo/OtherInfo";
import SignUpTnx from "./Pages/SignUpTnx/SignUpTnx";
import NeedPermis from "./Pages/NeedPermis/NeedPermis";
import { pdfjs } from "react-pdf";
import usePageUserTracking from "./Hooks/usePageUserTracking";
import InvestorProtected from "./Pages/InvestorProtected/InvestorProtected";
import ProductsProtected from "./Pages/ProductsProtected/ProductsProtected";
import NewsProtected from "./Pages/NewsProtected/NewsProtected";
import { QueryParamsProvider } from "./Context/QueryParamsProvider";
import ReDirecteContract from "./Components/Contracting/ReDirectContract";
import ReDirectESPEC from "./Components/ESPEC/ReDirectESPEC";
import RequestInfo from "./Pages/RequestInfo/RequestInfo";
import Reports from "./Pages/Reports/Reports";
import WankelStory from "./Pages/OurStory/Wankel";
import ConfirmEmailPage from "./Pages/ConfirmEmail/ConfirmEmail";
import Agreements from "./Pages/Agreements/Agreements";
import ArticlePage from "./Pages/Articles/Articles";
import IGMgmtDashboard from "./Pages/IGMgmtDashboard/IGMgmtDashboard";
import EspecDemo from "./Pages/EspecDemo/EspecDemo";
import EspecDemo2 from "./Pages/EspecDemo/EspecDemo2";
import Toronto from "./Content/TradeShow/Toronto";
import PipeDrivePage from "./Pages/PipeDrive/PipeDrivePage";
import EspecDemo3 from "./Pages/EspecDemo/EspecDemo3";
import EspecDemo4 from "./Pages/EspecDemo/EspecDemo4";
// import Arazona from "./Content/TradeShow/Arazona";
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url,
).toString();

// Initialize emailjs with the public key
emailjs.init(process.env.REACT_APP_EMAILJS_PUBLIC_KEY || "");
//windows 2022 server iis
//www.icegems.com

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};
// const referrer = document.referrer;
// if (referrer) {
//   console.log("User came from:", referrer);
// } else {
//   console.log("No referrer available (direct visit or blocked by browser).");
// }

function App() {
  return (
    <div className="App">
      <Router>
        <QueryParamsProvider>
          <UserProvider>
            <AuthProvider>
              <ScrollToTop />
              <AppContent />
            </AuthProvider>
          </UserProvider>
        </QueryParamsProvider>
      </Router>
      <script src="https://unpkg.com/ionicons@4.5.10-0/dist/ionicons.js"></script>
    </div>
  );
}

function AppContent() {
  usePageUserTracking();
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="sent" element={<Sent />} />
      <Route path="soon" element={<Soon />} />

      <Route path="/wankel" element={<WankelStory index={0} />} />
      {/* OurStory Routes*/}
      <Route path="/ourstory" element={<OurStory index={0} />} />
      {OurStorySec.map((item, index) => (
        <Route path={`/${item.id}`} element={<OurStory index={index} />} />
      ))}

      {/* Product Routes*/}
      <Route path="/products" element={<Products index={0} />} />
      {ProductsSec.map((item, index) => (
        <Route path={`/${item.id}`} element={<Products index={index} />} />
      ))}
      <Route path="/espec" element={<EspecDemo4 />} />
      <Route path="/espec-demo2" element={<EspecDemo2 />} />
      <Route path="/espec-demo3" element={<EspecDemo3 />} />
      <Route path="/espec-demo4" element={<EspecDemo />} />

      {/* News Routes*/}
      <Route path="/news" element={<News index={0} />} />
      {NewsSec.map((item, index) => (
        <Route path={`/${item.id}`} element={<News index={index} />} />
      ))}

      {/* Investment Routes*/}
      <Route path="/investment" element={<Investment index={0} />} />
      {InvestorSec.map((item, index) => (
        <Route path={`/${item.id}`} element={<Investment index={index} />} />
      ))}

      {/* <Route path="/arazona-tech-week-2026" element={<Arazona index={0} />} /> */}
      <Route path="/mississauga-truck-world-2026" element={<Toronto index={0} />} />

      <Route path="/team" element={<Leadership />} />
      <Route path="/article/:slug" element={<ArticlePage index={0} />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/request-info" element={<RequestInfo />} />
      <Route path="/sent" element={<Sent />} />
      <Route path="/soon" element={<Soon />} />
      <Route path="/thank-you" element={<SignUpTnx />} />
      <Route path="/need-permission" element={<NeedPermis />} />
      <Route path="/pipedrive" element={<PipeDrivePage index={0} />} />

      <Route path="/agreements" element={<Agreements />} />
      <Route
        path="/reports"
        element={
          <PrivateRoute>
            <Reports />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin-dashboard"
        element={
          <PrivateRoute>
            <IGMgmtDashboard />
          </PrivateRoute>
        }
      />

      <Route
        path="/contracts-admin"
        element={
          <PrivateRoute>
            <ReDirecteContract dest="ContractsDashboard" />
          </PrivateRoute>
        }
      />

      <Route
        path="/contracts-home"
        element={
          <PrivateRoute>
            <ReDirecteContract dest="ContractsHome" />
          </PrivateRoute>
        }
      />
      <Route
        path="/investor-protected"
        element={
          <PrivateRoute>
            <InvestorProtected />
          </PrivateRoute>
        }
      />

      <Route
        path="/products-protected"
        element={
          <PrivateRoute>
            <ProductsProtected />
          </PrivateRoute>
        }
      />

      <Route
        path="/news-protected"
        element={
          <PrivateRoute>
            <NewsProtected />
          </PrivateRoute>
        }
      />

      <Route path="/user-login" element={<UserLogin />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/email-confirmation" element={<ConfirmEmailPage />} />
      <Route path="/register" element={<Register />} />
      <Route
        path="/profile"
        element={
          <PrivateRoute>
            <Profile />
          </PrivateRoute>
        }
      />
      <Route
        path="/user-management"
        element={
          <PrivateRoute>
            <UserManagement />
          </PrivateRoute>
        }
      />
      <Route
        path="/user-management/add"
        element={
          <PrivateRoute>
            <UserForm />
          </PrivateRoute>
        }
      />
      <Route
        path="/user-management/edit/:userId"
        element={
          <PrivateRoute>
            <UserForm />
          </PrivateRoute>
        }
      />
      <Route
        path="/contact-management"
        element={
          <PrivateRoute>
            <ContactManagement />
          </PrivateRoute>
        }
      />
      <Route
        path="/contact-management/view/:cidn"
        element={
          <PrivateRoute>
            <ContactManagementView />
          </PrivateRoute>
        }
      />
      <Route
        path="/contact-management/add"
        element={
          <PrivateRoute>
            <ContactAdd />
          </PrivateRoute>
        }
      />
      <Route
        path="/contact-management/match"
        element={
          <PrivateRoute>
            <ContactMatch />
          </PrivateRoute>
        }
      />
      <Route
        path="/user-management/ContractStatus"
        element={
          <PrivateRoute>
            <ContractStatus />
          </PrivateRoute>
        }
      />
      <Route
        path="/user-management/UserActivity"
        element={
          <PrivateRoute>
            <UserActivity />
          </PrivateRoute>
        }
      />
      <Route
        path="/user-permissions"
        element={
          <PrivateRoute>
            <UserPermissionManager />
          </PrivateRoute>
        }
      />
      <Route
        path="/user-admin"
        element={
          <PrivateRoute>
            <RoleAdminDashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="/user-admin/roles"
        element={
          <PrivateRoute>
            <RoleEditor />
          </PrivateRoute>
        }
      />
      <Route
        path="/user-admin/permissions"
        element={
          <PrivateRoute>
            <PermissionEditor />
          </PrivateRoute>
        }
      />
      <Route
        path="/user-admin/assign-role-permissions"
        element={
          <PrivateRoute>
            <RolePermissionAssigner />
          </PrivateRoute>
        }
      />
      <Route
        path="/user-admin/assign-user-permissions"
        element={
          <PrivateRoute>
            <UserPermissionManager />
          </PrivateRoute>
        }
      />
      <Route
        path="/role-manager"
        element={
          <PrivateRoute>
            <RoleEditor />
          </PrivateRoute>
        }
      />
      <Route
        path="/espec-redirect"
        element={
          <PrivateRoute>
            <ReDirectESPEC />
          </PrivateRoute>
        }
      />
    </Routes>
  );
}

export default App;
